// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html .cog-name__group,:root:root:root:root:root .cog-name__group{display:flex;flex:1 1 18em}html .cog-form:not([data-old-safari]) .cog-name__group,:root:root:root:root:root .cog-form:not([data-old-safari]) .cog-name__group{column-gap:calc(var(--gutter)/2)}html .cog-name--narrow .cog-name__group,:root:root:root:root:root .cog-name--narrow .cog-name__group{flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
